import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CompanyAdminDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/companyAdmin/company');
  }, [navigate]);

  return <div />;
};

export default CompanyAdminDashboard;
